var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsletter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 17.5V30M30 30L35 25M30 30L25 25M7.5708 25L25.5615 37.0415C27.1652 38.1107 27.9672 38.6452 28.834 38.853C29.5997 39.0365 30.3983 39.0365 31.1643 38.853C32.031 38.6452 32.833 38.1107 34.4368 37.0415L52.4275 25M25.7453 10.172L11.2453 19.2782C9.87802 20.1369 9.19437 20.5662 8.6985 21.1466C8.25962 21.6603 7.9294 22.2577 7.72777 22.9025C7.5 23.6311 7.5 24.4384 7.5 26.053V42C7.5 44.8002 7.5 46.2005 8.04497 47.27C8.52432 48.2107 9.28923 48.9757 10.2301 49.455C11.2996 50 12.6997 50 15.5 50H44.5C47.3002 50 48.7005 50 49.77 49.455C50.7108 48.9757 51.4757 48.2107 51.955 47.27C52.5 46.2005 52.5 44.8002 52.5 42V26.053C52.5 24.4384 52.5 23.6311 52.2722 22.9025C52.0705 22.2577 51.7405 21.6603 51.3015 21.1466C50.8057 20.5662 50.122 20.1369 48.7547 19.2782L34.2547 10.172C32.7115 9.20297 31.94 8.71842 31.1122 8.52955C30.38 8.36255 29.62 8.36255 28.8878 8.52955C28.06 8.71842 27.2885 9.20297 25.7453 10.172Z",
    stroke: "black",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletter);
export default __webpack_public_path__ + "static/media/newsletter.4e6af26c815aba98acabd1a47b7e608e.svg";
export { ForwardRef as ReactComponent };